import { Box, Button, Drawer, IconButton, Typography } from "@mui/material";
import React from "react";
import { FaAngleLeft } from "react-icons/fa6";
import EnhancedSearchDropdown from "../EnhancedSearchDropdown";
import { Link } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import { HiMiniWrenchScrewdriver } from "react-icons/hi2";
import { PiPackageLight } from "react-icons/pi";

const MobileSearchDrawer = ({
  openDrawer,
  toggleDrawer,
  query,
  setQuery,
  setSearchData,
  searchData,
  navigateToSearchResults,
  renderHighlightedText,
  recentSearch
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [open, setOpen] = React.useState(false);

  const canBeOpen = open && Boolean(anchorEl);
  const id = canBeOpen ? "transition-popper" : undefined;
  return (
    <>
      <Drawer open={openDrawer} onClose={toggleDrawer}>
        <Box sx={{ width: "100vw", bgcolor: "#fff" }}>
          <Box
            sx={{ boxSizing: "border-box", p: 1.5, bgcolor: "#5C3069" }}
            aria-describedby={id}
          >
            <Box
              sx={{
                bgcolor: "#fff",
                borderRadius: "8px",
                p: 1,
                display: "flex",
                columnGap: 2,
                alignItems: "center",
              }}
            >
              <IconButton onClick={toggleDrawer}>
                <FaAngleLeft style={{ color: "#5c3069", fontSize: "15px" }} />
              </IconButton>
              <Box sx={{ flex: 1 }}>
                <EnhancedSearchDropdown
                  placeholder="I'm looking for products..."
                  size="small"
                  fullWidth
                  variant="outlined"
                  disablePopup={true}
                  value={query}
                  enableNavigation={true}
                  onSearch={(searchQuery, data) => {
                    setQuery(searchQuery);
                    setSearchData(data);
                  }}
                  style={{
                    input: {
                      fontSize: "12px",
                      fontWeight: 400,
                      borderRadius: "8px",
                      height: "35px",
                    },
                  }}
                />
              </Box>
            </Box>
          </Box>

          <Box sx={{ boxSizing: "border-box", width: "100%" }}>
            <Box
              sx={{
                zIndex: 1000,
                p: 2,
                bgcolor: "#fff",
                maxHeight: "400px",
                overflow: "auto",
                "&::-webkit-scrollbar": { display: "none" },
              }}
            >
              {searchData ? (
                <div>
                  {/* Recent Searches */}
                  {!searchData.query.trim() &&
                    searchData.recentSearches?.length > 0 && (
                      <Box sx={{ mb: 2 }}>
                        <Typography
                          sx={{
                            fontSize: "12px",
                            fontWeight: 600,
                            mb: 1,
                            color: "#666",
                          }}
                        >
                          Recent Searches
                        </Typography>
                        {searchData.recentSearches
                          .slice(0, 4)
                          .map((search, index) => (
                            <Box
                              key={index}
                              onClick={() => {
                                setQuery(search);
                                navigateToSearchResults(search);
                              }}
                              sx={{
                                py: 1,
                                px: 2,
                                cursor: "pointer",
                                "&:hover": { bgcolor: "#f5f5f5" },
                                borderRadius: 1,
                                mb: 0.5,
                              }}
                            >
                              <Typography
                                sx={{ fontSize: "13px", color: "#333" }}
                              >
                                {search}
                              </Typography>
                            </Box>
                          ))}
                      </Box>
                    )}

                  {/* Popular Searches */}
                  {!searchData.query.trim() &&
                    searchData.popularSearches?.length > 0 && (
                      <Box sx={{ mb: 2 }}>
                        <Typography
                          sx={{
                            fontSize: "12px",
                            fontWeight: 600,
                            mb: 1,
                            color: "#666",
                          }}
                        >
                          Popular Searches
                        </Typography>
                        {searchData.popularSearches
                          .slice(0, 6)
                          .map((search, index) => (
                            <Box
                              key={index}
                              onClick={() => {
                                setQuery(search);
                                navigateToSearchResults(search);
                              }}
                              sx={{
                                py: 1,
                                px: 2,
                                cursor: "pointer",
                                "&:hover": { bgcolor: "#f5f5f5" },
                                borderRadius: 1,
                                mb: 0.5,
                              }}
                            >
                              <Typography
                                sx={{ fontSize: "13px", color: "#333" }}
                              >
                                {search}
                              </Typography>
                            </Box>
                          ))}
                      </Box>
                    )}

                  {/* Products */}
                  {searchData.products?.length > 0 && (
                    <Box>
                      <Typography
                        sx={{
                          fontSize: "12px",
                          fontWeight: 600,
                          mb: 1,
                          color: "#666",
                        }}
                      >
                        {!searchData.query.trim() ? "Top Sellers" : "Products"}
                      </Typography>
                      {searchData.products.map((product, index) => (
                        <Link
                          key={product.objectID}
                          to={`/product-view/${product.objectID}`}
                          style={{ textDecoration: "none" }}
                          onClick={() => {
                            toggleDrawer(false)();
                            // Save search query to recent searches if available
                            if (query.trim()) {
                              const recentSearches = JSON.parse(
                                localStorage.getItem("recentSearches") || "[]",
                              );
                              const updated = [
                                query,
                                ...recentSearches.filter(
                                  (term) => term !== query,
                                ),
                              ].slice(0, 10);
                              localStorage.setItem(
                                "recentSearches",
                                JSON.stringify(updated),
                              );
                            }
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              py: 1.5,
                              px: 2,
                              "&:hover": { bgcolor: "#f5f5f5" },
                              borderRadius: 1,
                              mb: 1,
                            }}
                          >
                            {product.images && product.images[0] && (
                              <Box
                                component="img"
                                src={product.images[0]}
                                alt={product.name}
                                sx={{
                                  width: 40,
                                  height: 40,
                                  mr: 2,
                                  borderRadius: 1,
                                  objectFit: "cover",
                                }}
                              />
                            )}
                            <Box sx={{ flex: 1 }}>
                              <Typography
                                className="one-line-ellipsis"
                                sx={{
                                  fontSize: "12px",
                                  color: "#333",
                                  fontWeight: 700,
                                  mb: 0.5,
                                  "& mark": {
                                    backgroundColor: "#fff3cd",
                                    padding: "0 2px",
                                    borderRadius: "2px",
                                    fontWeight: "bold",
                                  },
                                }}
                                dangerouslySetInnerHTML={{
                                  __html: renderHighlightedText(
                                    product._highlightResult?.name?.value ||
                                      product.name,
                                  ),
                                }}
                              />
                              <Typography
                                className="two-line-ellipsis"
                                sx={{
                                  fontSize: "12px",
                                  color: "#333",
                                  fontWeight: 400,
                                  mb: 0.5,
                                  "& mark": {
                                    backgroundColor: "#fff3cd",
                                    padding: "0 2px",
                                    borderRadius: "2px",
                                    fontWeight: "bold",
                                  },
                                }}
                                dangerouslySetInnerHTML={{
                                  __html: renderHighlightedText(
                                    product._highlightResult?.description
                                      ?.value || product.description,
                                  ),
                                }}
                              />
                              <Typography
                                sx={{ fontSize: "11px", color: "#666" }}
                              >
                                $
                                {parseFloat(
                                  product.price || 0,
                                ).toLocaleString()}
                              </Typography>
                            </Box>
                          </Box>
                        </Link>
                      ))}

                      {/* Expand Search Button */}
                      {searchData.query.trim() &&
                        searchData.products?.length > 0 && (
                          <Box sx={{ p: 2, borderTop: "1px solid #f0f0f0" }}>
                            <Button
                              fullWidth
                              variant="outlined"
                              onClick={() => {
                                navigateToSearchResults(searchData.query);
                              }}
                              startIcon={<SearchIcon />}
                              sx={{
                                borderColor: "#5C3069",
                                color: "#5C3069",
                                "&:hover": {
                                  borderColor: "#5C3069",
                                  bgcolor: "#5C30690a",
                                },
                                textTransform: "none",
                                fontWeight: 600,
                                fontSize: "12px",
                                py: 1,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                gap: 0.5,
                              }}
                            >
                              <Box>View All Results</Box>
                              {searchData.totalHits >
                                searchData.products?.length && (
                                <Typography
                                  variant="caption"
                                  sx={{ fontSize: "10px", opacity: 0.8 }}
                                >
                                  {searchData.totalHits?.toLocaleString()} total
                                  results
                                </Typography>
                              )}
                            </Button>
                          </Box>
                        )}
                    </Box>
                  )}

                  {/* No Results */}
                  {searchData.query.trim() &&
                    searchData.products?.length === 0 &&
                    !searchData.isSearching && (
                      <Box sx={{ textAlign: "center", py: 3 }}>
                        <Typography
                          sx={{ fontSize: "12px", color: "#666", mb: 1 }}
                        >
                          No products found for "{searchData.query}"
                        </Typography>
                        <Typography sx={{ fontSize: "10px", color: "#999" }}>
                          Try different keywords or check spelling
                        </Typography>
                      </Box>
                    )}

                  {/* Loading */}
                  {searchData.isSearching && (
                    <Box sx={{ textAlign: "center", py: 3 }}>
                      <Typography sx={{ fontSize: "12px", color: "#666" }}>
                        Searching...
                      </Typography>
                    </Box>
                  )}
                </div>
              ) : (
                <Box sx={{ textAlign: "center", py: 3 }}>
                  <Typography sx={{ fontSize: "12px", color: "#666" }}>
                    Start typing to search products
                  </Typography>
                </Box>
              )}
            </Box>
          </Box>
          <Box sx={{ mt: 3, px: 2 }}>
            <Typography sx={{ fontSize: "12px", fontWeight: 400 }}>
              EVERYONE IS SEARCHING
            </Typography>
            <Box sx={{ mt: 2, display: "flex", gap: 2, flexWrap: "wrap" }}>
              {recentSearch.map((item, index) => (
                <>
                  <Box
                    sx={{
                      border: "1px solid #d7d7d7",
                      borderRadius: "50px",
                      height: "30px",
                      display: "flex",
                      alignItems: "center",
                      columnGap: 1,
                      width: "fit-content",
                      pl: 0.3,
                      pr: 1,
                      bgcolor: item?.label === query && "#5C30691a",
                    }}
                    key={index}
                    onClick={() => {
                      setQuery(item?.label);
                      navigateToSearchResults(item?.label);
                    }}
                  >
                    <Box
                      sx={{
                        height: "25px",
                        width: "25px",
                        borderRadius: "50%",
                        boxSizing: "border-box",
                        bgcolor: "#5C3069",
                        display: "grid",
                        placeContent: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "#fff",
                          fontSize: "10px",
                          fontWeight: 900,
                        }}
                      >
                        {item?.type === "product" ? (
                          <PiPackageLight />
                        ) : (
                          <HiMiniWrenchScrewdriver />
                        )}
                      </Typography>
                    </Box>
                    <Typography sx={{ fontSize: "10px", fontWeight: 400 }}>
                      {item.label}
                    </Typography>
                  </Box>
                </>
              ))}
            </Box>
          </Box>
        </Box>
      </Drawer>
    </>
  );
};

export default MobileSearchDrawer;
